"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MyTasksTab;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
const CommonComponents_1 = require("../../View/Resultsets/CommonComponents");
const FilterableTable_1 = __importDefault(require("../../View/Resultsets/FilterableTable/FilterableTable"));
const TasksGlobalModalButtons_1 = require("../../TasksGlobal/Modals/TasksGlobalModalButtons");
const buildScrumTree_1 = require("../CurrentSprint/buildScrumTree");
const ScrumTaskRow_1 = __importDefault(require("../CurrentSprint/ScrumTaskRow"));
const ScrumboardApi_1 = __importDefault(require("../ScrumboardApi"));
const ScrumboardController_1 = require("../ScrumboardController");
const MyTasksFilterPanel_1 = __importDefault(require("./MyTasksFilterPanel"));
/** Zakładka "Moje zadania": zadania zalogowanego użytkownika (lub wybranej osoby dla ADMIN/MANAGER). */
function MyTasksTab() {
    const isManager = MainSetupReact_1.default.isRoleAllowed(["ADMIN", "ENVI_MANAGER"]);
    const [persons, setPersons] = (0, react_1.useState)([]);
    const [selectedPerson, setSelectedPerson] = (0, react_1.useState)(undefined);
    const [ownerData, setOwnerData] = (0, react_1.useState)([]);
    const [fullData, setFullData] = (0, react_1.useState)([]);
    const [fullTree, setFullTree] = (0, react_1.useState)(false);
    const [onlyMine, setOnlyMine] = (0, react_1.useState)(false);
    const [hoursFilledOnly, setHoursFilledOnly] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [externalUpdate, setExternalUpdate] = (0, react_1.useState)(0);
    const [filter, setFilter] = (0, react_1.useState)({});
    const selfId = MainSetupReact_1.default.getCurrentUserAsPerson()?.id;
    const filterCaseId = filter._case?.id;
    // Inicjalizacja: lista osób + domyślnie zalogowany na górze
    (0, react_1.useEffect)(() => {
        async function init() {
            const self = MainSetupReact_1.default.getCurrentUserAsPerson();
            if (!isManager) {
                if (self) {
                    setPersons([self]);
                    setSelectedPerson(self);
                }
                return;
            }
            // pracownicy ENVI + manager z configu (id 386) — te same osoby co w Podsumowaniu/Planowaniu
            const scrumboardPersons = await ScrumboardApi_1.default.getPersons();
            const ordered = self
                ? [self, ...scrumboardPersons.filter((p) => p.id !== self.id)]
                : scrumboardPersons;
            setPersons(ordered);
            setSelectedPerson(self ?? ordered[0]);
        }
        init();
    }, [isManager]);
    // Drzewo zadań osoby (tylko gałęzie z jej zadaniami — filtr po stronie serwera).
    // Kontrakt i statusy z panelu filtrów doładowywane z serwera (jak w „Projekty i zadania").
    (0, react_1.useEffect)(() => {
        if (!selectedPerson)
            return;
        async function load() {
            setLoading(true);
            const condition = { _owner: selectedPerson };
            if (filter._contract)
                condition._contract = filter._contract;
            if (filter.statuses && filter.statuses.length)
                condition.statuses = filter.statuses;
            else
                condition.statusType = "active";
            const result = (await ScrumboardController_1.scrumContractsWithChildrenRepository.loadItemsFromServerPOST([condition], undefined, { skipCache: true }));
            setOwnerData(result);
            setFullData([]); // unieważnij pełne drzewo poprzedniej osoby / filtra
            setExternalUpdate((n) => n + 1);
            setLoading(false);
        }
        load();
    }, [selectedPerson, filter]);
    // Pełne drzewo (wszystkie zadania w kontraktach osoby) — ładowane leniwie po włączeniu przełącznika
    (0, react_1.useEffect)(() => {
        if (!fullTree || fullData.length > 0 || ownerData.length === 0)
            return;
        async function loadFull() {
            setLoading(true);
            const orConditions = ownerData.map((c) => ({ contractId: c.contract.id, statusType: "active" }));
            const result = (await ScrumboardController_1.scrumContractsWithChildrenRepository.loadItemsFromServerPOST(orConditions, undefined, { skipCache: true }));
            setFullData(result);
            setExternalUpdate((n) => n + 1);
            setLoading(false);
        }
        loadFull();
    }, [fullTree, ownerData, fullData.length]);
    // nie pokazuj kontraktów zakończonych
    const data = (fullTree && fullData.length > 0 ? fullData : ownerData).filter((c) => c.contract.status !== MainSetupReact_1.default.ContractStatuses.FINISHED);
    // Zmiana filtrów musi wymusić odświeżenie sekcji w FilterableTable
    (0, react_1.useEffect)(() => {
        setExternalUpdate((n) => n + 1);
    }, [fullTree, onlyMine, hoursFilledOnly]);
    const sections = (0, react_1.useMemo)(() => (0, buildScrumTree_1.buildScrumTree)(data, {
        leavesRepository: ScrumboardController_1.scrumMyTasksRepository,
        ownerId: onlyMine ? selfId : undefined,
        hoursFilledOnly,
        caseId: filterCaseId,
    }), [data, onlyMine, hoursFilledOnly, selfId, filterCaseId]);
    const tree = loading ? (react_1.default.createElement(CommonComponents_1.SpinnerBootstrap, null)) : ownerData.length === 0 ? (react_1.default.createElement("div", { className: "text-muted p-3" }, "Brak zada\u0144 przypisanych do tej osoby.")) : (react_1.default.createElement(FilterableTable_1.default, { id: `scrumMyTasks_${selectedPerson?.id ?? "none"}_${fullTree ? "full" : "own"}`, title: "Moje zadania", showTableHeader: false, repository: ScrumboardController_1.scrumMyTasksRepository, EditButtonComponent: TasksGlobalModalButtons_1.TaskEditModalButton, initialSections: sections, snapshotMode: "criteria-only", externalUpdate: externalUpdate, tableStructure: [
            {
                header: "Zadania",
                renderTdBody: (task, isActive) => (react_1.default.createElement(ScrumTaskRow_1.default, { task: task, isActive: isActive })),
                colLg: 11,
            },
        ] }));
    return (react_1.default.createElement(react_bootstrap_1.Row, null,
        react_1.default.createElement(react_bootstrap_1.Col, { md: "3" },
            react_1.default.createElement(MyTasksFilterPanel_1.default, { onApply: setFilter, toggles: {
                    fullTree,
                    onlyMine,
                    hoursFilledOnly,
                    setFullTree,
                    setOnlyMine,
                    setHoursFilledOnly,
                } }),
            isManager && (react_1.default.createElement(react_bootstrap_1.ListGroup, null, persons.map((person) => (react_1.default.createElement(react_bootstrap_1.ListGroup.Item, { key: person.id, action: true, active: person.id === selectedPerson?.id, onClick: () => setSelectedPerson(person) },
                person.name,
                " ",
                person.surname)))))),
        react_1.default.createElement(react_bootstrap_1.Col, { md: "9" }, tree)));
}
